import { oz } from '@vy/utils';

export const PRO_RATA_SETTINGS = Object.freeze({
  DISABLED: 'disabled',
  PRO_RATA: 'proRata',
  PRO_RATA_AND_CALENDAR_ALIGNED: 'proRataAndCalendarAligned',
});

export const ProRateSettingsSchema = oz.nativeEnum(PRO_RATA_SETTINGS);

export type ProRataSettings = oz.infer<typeof ProRateSettingsSchema>;

export function mapProRataSettingToProductFields(setting: ProRataSettings): {
  proRata: boolean;
  isCalendarAligned: boolean;
} {
  switch (setting) {
    case PRO_RATA_SETTINGS.PRO_RATA_AND_CALENDAR_ALIGNED:
      return { proRata: true, isCalendarAligned: true };
    case PRO_RATA_SETTINGS.PRO_RATA:
      return { proRata: true, isCalendarAligned: false };
    case PRO_RATA_SETTINGS.DISABLED:
    default:
      return { proRata: false, isCalendarAligned: false };
  }
}

export function isProRated(setting: ProRataSettings): boolean {
  return setting === PRO_RATA_SETTINGS.PRO_RATA_AND_CALENDAR_ALIGNED;
}
